export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
      const randomInt = Math.random() * 16 | 0;
      const value = character === 'x' ? randomInt : (randomInt & 0x3 | 0x8);
      return value.toString(16);
    });
  }
}
